import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { ArquivoService } from 'src/app/_services/arquivo.service';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Arquivo } from 'src/app/_models/arquivo/arquivo';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';
import { Perfil } from 'src/app/_models/usuario/perfil';
import { Usuario } from 'src/app/_models/usuario/usuario';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Cedente } from 'src/app/_models/cedente/cedente';
import { CedenteService } from 'src/app/_services/cedente.service';
import { DatePipe } from '@angular/common';
import { Table } from 'primeng/table';
import { FilterArquivo } from 'src/app/_models/filter/FilterArquivo';
import { FilterArquivoHeader } from 'src/app/_models/filter/FilterArquivoHeader';
import { Banco } from 'src/app/_models/banco/banco';
import { BancoService } from 'src/app/_services/banco.service';

@Component({
  templateUrl: 'arquivo.component.html',
  styleUrls: ['../../demo/view/tabledemo.scss', 'arquivo.scss'],
    styles: [`
        :host ::ng-deep .p-dialog .product-image {
            width: 150px;
            margin: 0 auto 2rem auto;
            display: block;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:last-child {
                text-align: center;
            }

            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, DatePipe]
})
export class ArquivoComponent implements OnInit {

  arquivoDialog: boolean;
  arquivos: Arquivo[];
  arquivo: Arquivo;
  selectedArquivos: Arquivo[];
  submitted: boolean;
  cols: any[];
  pesquisarArquivoLabel: string;
  perfil: Perfil;
  currentUsuario: Usuario;
  filteredCedentes: Cedente[];
  cedentes: Cedente[];
  cedente: Cedente;
  header: any[];
  filterArquivo: FilterArquivo  = {};

  listaTpoSentido: string[] = [
    "CSV",
    "REMESSA",
    "RETORNO",
  ];
  filteredTpoSentido: string[] = [];
  tpoSentidoSel: string;

  listaDscStatus: string[] = [
    "Arquivo Duplicado",
    "Carregado com Sucesso",
    "Carregado com pendencias",
  ];
  filteredDscStatus: string[] = [];
  dscStatusSel: string;

  filterArquivoHeader: FilterArquivoHeader = {};

  bancosArr: Banco[] = [];
  filteredBanco: Banco[] = [];
  bancoSel?: Banco;

  busca: string;

  @ViewChild('dt', {static: false}) dt: Table;

  constructor(private arquivoService: ArquivoService, private breadcrumbService: AppBreadcrumbService,
              private bscobrancaTranslate: BscobrancaTranslate, private authenticationService: AuthenticationService,
              private cedenteService: CedenteService, private datepipe: DatePipe,
              private bancoService: BancoService) {
    this.pesquisarArquivoLabel = this.bscobrancaTranslate.getText('menu.pesquisarArquivo');
    this.breadcrumbService.setItems([
        { label: this.pesquisarArquivoLabel, routerLink: ['/arquivo/arquivo']  }
    ]);
    this.header = ['Cedente', 'Codigo Banco', 'Nome Arquivo', 'Qtde. Registros', 'Data Inclusao', 'Inicio Carga', 'Fim Carga' , 'Status'];
  }

  pt: {};
   ngOnInit(): void {
     this.currentUsuario = this.authenticationService.atualUserValue;
     this.perfil = this.authenticationService.atualUserPerfilValue;
     this.cedenteService.getCedentesPorEmpresa(-1)
            .subscribe(ceds => {
            this.cedentes = Array.from(ceds);
            });
     if (this.perfil.nmePerfil === 'ADMTIVIT' || this.perfil.nmePerfil === 'MNGTIVIT' || this.perfil.nmePerfil === 'OPRTIVIT') {
         this.arquivoService.getAll().toPromise().then(data => this.arquivos = data);
     } else {
        const currentUsuarioFilterArquivoHeader = new FilterArquivoHeader();
        currentUsuarioFilterArquivoHeader.nroDocumento = this.currentUsuario.empresa.nroCNPJ;
        this.arquivoService.getAllPorEmpresa(currentUsuarioFilterArquivoHeader).toPromise().then(data => this.arquivos = data);
     }

     this.bancoService.getAllBancoTodos().subscribe(bancos => {
        this.bancosArr = bancos
        this.bancosArr = this.bancosArr.filter((e) => {
            if(e.situacao === 'ATIVO') {
                return e;
            }
        })
    });
    this.listaTpoSentido = [
        "CSV",
        "REMESSA",
        "RETORNO",
    ];
    this.listaDscStatus = [
        "Arquivo Duplicado",
        "Carregado com Sucesso",
        "Carregado com pendencias",
    ];
    this.pt = {
        firstDayOfWeek: 0,
        dayNames: ['Domingo', 'Segunda', 'Ter?a', 'Quarta', 'Quinta', 'Sexta', 'S?bado'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
        monthNames: ['Janeiro', 'Fevereiro', 'Mar?o', 'Abril', 'Maio', 'Junho', 'Julho',
            'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        today: 'Hoje',
        clear: 'Limpar'
    };
   }

   pesquisarArquivo() {
    if (!!this.bancoSel) {
        this.filterArquivoHeader.codBanco = this.bancoSel.codBanco;
    }
    if (!!this.cedente) {
        this.filterArquivoHeader.nroDocumento = this.cedente.codInscricao;
    }
    if (!!this.tpoSentidoSel) {
        this.filterArquivoHeader.tpoSentido = this.tpoSentidoSel;
    }
    if (!!this.dscStatusSel) {
        this.filterArquivoHeader.dscStatus = this.dscStatusSel;
    }
    if (!!this.filterArquivoHeader.nroDocumento
        || !!this.filterArquivoHeader.dtaInicio
        || !!this.filterArquivoHeader.dtaFim
        || !!this.filterArquivoHeader.fileName
        || !!this.filterArquivoHeader.nsa
        || !!this.filterArquivoHeader.codBanco
        || !!this.filterArquivoHeader.tpoSentido
        || !!this.filterArquivoHeader.dscStatus
    ) {
        this.arquivoService.getAllPorParametros(this.filterArquivoHeader).toPromise().then(data => this.arquivos = data);
    } else {
       this.arquivoService.getAll().toPromise().then(data => this.arquivos = data);
    }
   }

   filterBanco(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        for (let i = 0; i < this.bancosArr.length; i++) {
            let banco: Banco = this.bancosArr[i];
            const nome = banco.nmeBanco;
            if (nome.toLowerCase().includes(query.toLowerCase())) {
                filtered.push(banco);
            }
        }
        this.filteredBanco = filtered;
    }

    filterTpoSentido(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        for (let i = 0; i < this.listaTpoSentido.length; i++) {
            let tipoArquivo: String = this.listaTpoSentido[i];
            const nome = tipoArquivo;
            if (nome.toLowerCase().includes(query.toLowerCase())) {
                filtered.push(tipoArquivo);
            }
        }
        this.filteredTpoSentido = filtered;
    }

    filterDscStatus(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        for (let i = 0; i < this.listaDscStatus.length; i++) {
            let dscStatus: String = this.listaDscStatus[i];
            const nome = dscStatus;
            if (nome.toLowerCase().includes(query.toLowerCase())) {
                filtered.push(dscStatus);
            }
        }
        this.filteredDscStatus = filtered;
    }

   downloadFile(filename= 'arquivos') {
        const csvData = this.ConvertToCSV(this.header);
        console.log(csvData);
        const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        const dwldLink = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
            dwldLink.setAttribute('target', '_blank');
        }
        dwldLink.setAttribute('href', url);
        dwldLink.setAttribute('download', filename + '.csv');
        dwldLink.style.visibility = 'hidden';
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
   }

    limparFormulario(): void {
        this.cedente = {};
        this.arquivos = [];
        this.busca = '';
        this.filterArquivo = {};
        this.filterArquivoHeader = {};
        this.filteredBanco = [];
        this.bancoSel = {};
        this.filteredTpoSentido = [];
        this.tpoSentidoSel = '';
        this.filteredDscStatus = [];
        this.dscStatusSel = '';
        this.dt.clear();
        if (this.perfil.nmePerfil === 'ADMTIVIT' || this.perfil.nmePerfil === 'MNGTIVIT' || this.perfil.nmePerfil === 'OPRTIVIT') {
         this.arquivoService.getAll().toPromise().then(data => this.arquivos = data);
        } else {
            const currentUsuarioFilterArquivoHeader = new FilterArquivoHeader();
            currentUsuarioFilterArquivoHeader.nroDocumento = this.currentUsuario.empresa.nroCNPJ;
            this.arquivoService.getAllPorEmpresa(currentUsuarioFilterArquivoHeader).toPromise().then(data => this.arquivos = data);
        }
        this.bancoService.getAllBancoTodos().subscribe(bancos => {
            this.bancosArr = bancos
            this.bancosArr = this.bancosArr.filter((e) => {
               if(e.situacao === 'ATIVO') {
                   return e;
               }
           })
       });
    }

   filterCedentes(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        for (let i = 0; i < this.cedentes.length; i++) {
            const cedente = this.cedentes[i];
            if (cedente.nmeCedente.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(cedente);
            }
        }

        this.filteredCedentes = filtered;
    }

    ConvertToCSV(headerList: any[]) {
         let str = '';
         let row = 'No;';
         for (const index in headerList) {
             row += headerList[index] + ';';
         }
         row = row.slice(0, -1);
         str += row + '\r\n';
         for (let i = 0; i < this.arquivos.length; i++) {
             const arq = this.arquivos[i];
             let line = (i + 1) + ';';
             line += arq.nomeEmpresa + ';';
             line += arq.codBanco + ';';
             line += arq.nmeArquivo + ';';
             line += Number(arq.nroQtdRegistros) + ';';
             line += this.datepipe.transform(arq.dtaCriacao, 'dd/MM/yyyy hh:mm:ss') + ';';
             line += this.datepipe.transform(arq.dtaIniciocarga, 'dd/MM/yyyy HH:mm:ss') + ';';
             line += this.datepipe.transform(arq.dtaFimcarga, 'dd/MM/yyyy HH:mm:ss') + ';';
             line += arq.dscStatuscarga + ';';
             str += line + '\r\n';
         }
         return str;
     }

     exportOptions = [
        {label: 'PDF', icon: 'pi pi-file-pdf', command: (x) => this.exportarConsultaArquivos('PDF') },
        {label: 'XLS', icon: 'pi pi-file-excel', command: (x) => this.exportarConsultaArquivos('XLSX')}
    ];

    exportarConsultaArquivos(formato: string) {
        if (!!this.cedente) {
            this.filterArquivoHeader.nroDocumento = this.cedente.codInscricao;
        }
        if (!!this.bancoSel) {
            this.filterArquivo.codBanco = this.bancoSel.codBanco;
        }
        if (!!this.tpoSentidoSel) {
            this.filterArquivo.tpoSentido = this.tpoSentidoSel;
        }
        if (!!this.dscStatusSel) {
            this.filterArquivo.dscStatus = this.dscStatusSel;
        }
        if (!!this.filterArquivoHeader.dtaInicio) {
            this.filterArquivo.dtaInicio = this.filterArquivoHeader.dtaInicio;
        }
        if (!!this.filterArquivoHeader.dtaFim) {
            this.filterArquivo.dtaFim = this.filterArquivoHeader.dtaFim;
        }
        if (!!this.filterArquivoHeader.fileName) {
            this.filterArquivo.fileName = this.filterArquivoHeader.fileName;
        }
        if (!!this.filterArquivoHeader.nsa) {
            this.filterArquivo.nsa = this.filterArquivoHeader.nsa;
        }
        this.filterArquivo.formatoRelatorio = formato;

        this.arquivoService.exportarRelatorioArquivos(this.filterArquivo).subscribe((res: any) => {

            const file = new Blob([res], {
                type: res.type,

            });
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Arquivos.` + formato;
            link.click();
            window.URL.revokeObjectURL(url);
            link.remove();
        });
    }

}
